(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui-util'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'compose-multiplatform-core-compose-ui-ui-util'.");
    }
    globalThis['compose-multiplatform-core-compose-ui-ui-util'] = factory(typeof globalThis['compose-multiplatform-core-compose-ui-ui-util'] === 'undefined' ? {} : globalThis['compose-multiplatform-core-compose-ui-ui-util'], globalThis['kotlin-kotlin-stdlib']);
  }
}(function (_, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var VOID = kotlin_kotlin.$_$.d;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.w4;
  var NoSuchElementException_init_$Create$ = kotlin_kotlin.$_$.d6;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var toString = kotlin_kotlin.$_$.hh;
  var Char = kotlin_kotlin.$_$.ym;
  var isCharSequence = kotlin_kotlin.$_$.ng;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.z3;
  var roundToInt = kotlin_kotlin.$_$.kh;
  var isNaN_0 = kotlin_kotlin.$_$.ro;
  var toRawBits = kotlin_kotlin.$_$.fp;
  var fromInt = kotlin_kotlin.$_$.pe;
  var Long = kotlin_kotlin.$_$.kn;
  var bitwiseAnd = kotlin_kotlin.$_$.ge;
  var divide = kotlin_kotlin.$_$.ne;
  var convertToInt = kotlin_kotlin.$_$.le;
  var FloatCompanionObject_instance = kotlin_kotlin.$_$.v2;
  var floatFromBits = kotlin_kotlin.$_$.uf;
  //endregion
  //region block: pre-declaration
  //endregion
  function fastJoinToString(_this__u8e3s4, separator, prefix, postfix, limit, truncated, transform) {
    separator = separator === VOID ? ', ' : separator;
    prefix = prefix === VOID ? '' : prefix;
    postfix = postfix === VOID ? '' : postfix;
    limit = limit === VOID ? -1 : limit;
    truncated = truncated === VOID ? '...' : truncated;
    transform = transform === VOID ? null : transform;
    return fastJoinTo(_this__u8e3s4, StringBuilder_init_$Create$(), separator, prefix, postfix, limit, truncated, transform).toString();
  }
  function throwNoSuchElementException(message) {
    throw NoSuchElementException_init_$Create$(message);
  }
  function fastJoinTo(_this__u8e3s4, buffer, separator, prefix, postfix, limit, truncated, transform) {
    separator = separator === VOID ? ', ' : separator;
    prefix = prefix === VOID ? '' : prefix;
    postfix = postfix === VOID ? '' : postfix;
    limit = limit === VOID ? -1 : limit;
    truncated = truncated === VOID ? '...' : truncated;
    transform = transform === VOID ? null : transform;
    buffer.k1(prefix);
    var count = 0;
    var inductionVariable = 0;
    var last = _this__u8e3s4.n1() - 1 | 0;
    if (inductionVariable <= last)
      $l$loop: do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var element = _this__u8e3s4.l1(index);
        count = count + 1 | 0;
        if (count > 1) {
          buffer.k1(separator);
        }
        if (limit < 0 || count <= limit) {
          appendElement(buffer, element, transform);
        } else
          break $l$loop;
      }
       while (inductionVariable <= last);
    if (limit >= 0 && count > limit) {
      buffer.k1(truncated);
    }
    buffer.k1(postfix);
    return buffer;
  }
  function appendElement(_this__u8e3s4, element, transform) {
    if (!(transform == null))
      _this__u8e3s4.k1(transform(element));
    else {
      if (element == null ? true : isCharSequence(element))
        _this__u8e3s4.k1(element);
      else {
        if (element instanceof Char)
          _this__u8e3s4.s(element.f2_1);
        else {
          _this__u8e3s4.k1(toString(element));
        }
      }
    }
  }
  function fastFilterNotNull(_this__u8e3s4) {
    var target = ArrayList_init_$Create$(_this__u8e3s4.n1());
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = _this__u8e3s4.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = _this__u8e3s4.l1(index);
        if (!(item == null)) {
          // Inline function 'kotlin.collections.plusAssign' call
          target.j1(item);
        }
      }
       while (inductionVariable <= last);
    return target;
  }
  function lerp(start, stop, fraction) {
    return (1 - fraction) * start + fraction * stop;
  }
  function lerp_0(start, stop, fraction) {
    // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
    var this_0 = (stop - start | 0) * fraction;
    return start + (isNaN_0(this_0) ? 0 : roundToInt(this_0)) | 0;
  }
  function fastCbrt(x) {
    var v = bitwiseAnd(fromInt(toRawBits(x)), new Long(-1, 1));
    // Inline function 'kotlin.Long.div' call
    var tmp$ret$0 = divide(v, fromInt(3));
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = 709952852 + convertToInt(tmp$ret$0) | 0;
    var estimate = floatFromBits(bits);
    estimate = estimate - (estimate - x / (estimate * estimate)) * (1.0 / 3.0);
    estimate = estimate - (estimate - x / (estimate * estimate)) * (1.0 / 3.0);
    return estimate;
  }
  function traceValue(tag, value) {
  }
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = fastCbrt;
  _.$_$.b = fastFilterNotNull;
  _.$_$.c = fastJoinToString;
  _.$_$.d = lerp;
  _.$_$.e = lerp_0;
  _.$_$.f = throwNoSuchElementException;
  _.$_$.g = traceValue;
  //endregion
  return _;
}));

//# sourceMappingURL=compose-multiplatform-core-compose-ui-ui-util.js.map
